<template>
  <div class="rating-selector">
    <div
      v-for="(rating, index) in availableRatings"
      :id="`star-${rating}`"
      :key="rating"
      class="rating-pip"
      :class="{ 'rating-pip-active': value !== null && rating <= value }"
      :style="{ 'line-height': size + 'px', 'margin-left': (index !== 0 ? spacing : 0) + 'px' }"
      @click="selectRating(rating)"
    >
      <i class="sr-2 sr-v2-star-filled" :style="{ 'font-size': size + 'px' }" />
    </div>
  </div>
</template>

<script>
import range from "lodash/range";

export default {
  props: {
    value: { required: true },
    maxRating: { type: Number, default: 5 },
    size: { type: Number, default: 12 },
    spacing: { type: Number, default: 8 }
  },

  computed: {
    availableRatings() {
      return range(1, this.maxRating + 1);
    }
  },

  methods: {
    selectRating(rating) {
      this.$emit("input", rating);
    }
  }
};
</script>

<style lang="scss" scoped>
.rating-selector {
  display: flex;
}
.rating-pip {
  cursor: pointer;
}
.rating-pip i {
  color: #c4c4c4;
}
.rating-pip-active i {
  color: #ffa05f;
}
</style>